import { siteInfo } from '@/mocks/comics';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import FeaturedSection from './components/FeaturedSection';
import LatestSection from './components/LatestSection';
import RankingSection from './components/RankingSection';
import TestimonialSection from './components/TestimonialSection';
import CTASection from './components/CTASection';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: siteInfo.name,
  url: 'http://w340q.cn/',
  description: siteInfo.description,
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: 'http://w340q.cn/category/all?search={search_term_string}',
    },
    'query-input': 'required name=search_term_string',
  },
  inLanguage: 'zh-CN',
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: siteInfo.name,
  url: 'http://w340q.cn/',
  description: siteInfo.description,
  email: siteInfo.contactEmail,
  address: {
    '@type': 'PostalAddress',
    addressLocality: siteInfo.address,
  },
};

const webPageSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: `${siteInfo.name} - 免费在线韩漫阅读网`,
  description: siteInfo.description,
  url: 'http://w340q.cn/',
  isPartOf: {
    '@type': 'WebSite',
    name: siteInfo.name,
    url: 'http://w340q.cn/',
  },
  inLanguage: 'zh-CN',
};

export default function Home() {
  return (
    <>
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(webPageSchema)}</script>
      <HeroSection />
      <CategorySection />
      <FeaturedSection />
      <LatestSection />
      <RankingSection />
      <TestimonialSection />
      <CTASection />
    </>
  );
}